import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { ShellComponent } from './layout/shell/shell.component';
import { adminGuard } from './core/guards/admin.guard';
import { supervisorGuard } from './core/guards/supervisor.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./features/auth/auth-layout/auth-layout.component').then(
        m => m.AuthLayoutComponent
      ),
    children: [
      {
        path: 'redirect',
        component: MsalRedirectComponent,
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'unauthorized',
        loadComponent: () =>
          import('./features/auth/unauthorized/unauthorized.component').then(
            m => m.UnauthorizedComponent
          ),
      },
    ],
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [MsalGuard, supervisorGuard],
    children: [
      { path: '', redirectTo: 'cases', pathMatch: 'full' },
      {
        path: 'forms',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Dynamic Forms' },
        loadComponent: () =>
          import('./features/dynamic-forms/forms-list/forms-list.component').then(
            m => m.FormsListComponent
          ),
      },
      {
        path: 'forms/new',
        canActivate: [adminGuard],
        data: { breadcrumb: 'New Form' },
        loadComponent: () =>
          import('./features/dynamic-forms/form-editor/form-editor.component').then(
            m => m.FormEditorComponent
          ),
      },
      {
        path: 'forms/:id',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Edit Form' },
        loadComponent: () =>
          import('./features/dynamic-forms/form-editor/form-editor.component').then(
            m => m.FormEditorComponent
          ),
      },
      {
        path: 'users',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Users' },
        loadComponent: () =>
          import('./features/users/users-list/users-list.component').then(
            m => m.UsersListComponent
          ),
      },
      {
        path: 'cases',
        data: { breadcrumb: 'Cases' },
        loadComponent: () =>
          import('./features/cases/cases-list/cases-list.component').then(
            m => m.CasesListComponent
          ),
      },
      {
        path: 'cases/:id',
        data: { breadcrumb: 'Case Detail' },
        loadComponent: () =>
          import('./features/cases/case-detail/case-detail.component').then(
            m => m.CaseDetailComponent
          ),
      },
      {
        path: 'case-history',
        data: { breadcrumb: 'Case Export History' },
        loadComponent: () =>
          import('./features/cases/case-history/case-history.component').then(
            m => m.CaseHistoryComponent
          ),
      },
      {
        path: 'graphql-explorer',
        canActivate: [adminGuard],
        data: { breadcrumb: 'GraphQL Explorer' },
        loadComponent: () =>
          import('./features/graphql-explorer/graphql-explorer.component').then(
            m => m.GraphqlExplorerComponent
          ),
      },
      {
        path: 'hangfire',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Hangfire Dashboard' },
        loadComponent: () =>
          import('./features/hangfire/hangfire-dashboard.component').then(
            m => m.HangfireDashboardComponent
          ),
      },
      {
        path: 'extension-upload',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Upload Chrome Extension' },
        loadComponent: () =>
          import('./features/extension-upload/extension-upload.component').then(
            m => m.ExtensionUploadComponent
          ),
      },
      {
        path: 'countries',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Countries' },
        loadComponent: () =>
          import('./features/countries/countries-list/countries-list.component').then(
            m => m.CountriesListComponent
          ),
      },
      {
        path: 'countries/new',
        canActivate: [adminGuard],
        data: { breadcrumb: 'New Country' },
        loadComponent: () =>
          import('./features/countries/country-editor/country-editor.component').then(
            m => m.CountryEditorComponent
          ),
      },
      {
        path: 'countries/:id',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Edit Country' },
        loadComponent: () =>
          import('./features/countries/country-editor/country-editor.component').then(
            m => m.CountryEditorComponent
          ),
      },
      {
        path: 'content-templates',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Content Templates' },
        loadComponent: () =>
          import('./features/content-templates/content-templates-list/content-templates-list.component').then(
            m => m.ContentTemplatesListComponent
          ),
      },
      {
        path: 'content-templates/new',
        canActivate: [adminGuard],
        data: { breadcrumb: 'New Content Template' },
        loadComponent: () =>
          import('./features/content-templates/content-template-editor/content-template-editor.component').then(
            m => m.ContentTemplateEditorComponent
          ),
      },
      {
        path: 'content-templates/:id',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Edit Content Template' },
        loadComponent: () =>
          import('./features/content-templates/content-template-editor/content-template-editor.component').then(
            m => m.ContentTemplateEditorComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
